<template>
  <skud-visit-form v-if="isCreate" />
  <skud-visit-view v-else />
</template>

<script>
import SkudVisitForm from '@/views/skud/components/SkudVisitForm.vue'
import SkudVisitView from '@/views/skud/components/SkudVisitView.vue'

export default {
  name: 'SkudVisitPage',
  components: { SkudVisitForm, SkudVisitView },
  computed: {
    isCreate () {
      return this.$route.path.endsWith('create')
    }
  }
}
</script>
